module.exports = __webpack_public_path__ + "static/media/Poker-banner.09f9180a.png";